

// import React, { useEffect, useState } from "react";
// import { Routes, useLocation } from "react-router-dom";
// import { PublicClientApplication } from "@azure/msal-browser";
// import { MsalProvider } from "@azure/msal-react";

// import { msalConfig } from "./auth/authConfig";
// import UserRoutes from "./routes/userRoutes";
// import AdminRoutes from "./routes/adminRoutes";
// import { AuthProvider } from "./auth/AuthContext";
// import GlassLoaderOverlay from "./components/GlassLoader";

// const LoadingPage = () => <GlassLoaderOverlay />;

// const msalInstance = new PublicClientApplication(msalConfig);

// function App() {
//   const [msalReady, setMsalReady] = useState(false);

//   useEffect(() => {
//     const initMsal = async () => {
//       try {
//         await msalInstance.initialize();
//         setMsalReady(true);
//       } catch (err) {
//         console.error("MSAL initialization failed", err);
//       }
//     };
//     initMsal();
//   }, []);

//   if (!msalReady) return <LoadingPage />;

//   return <RouteHandler />;
// }

// // Detect whether route is admin or user
// function RouteHandler() {
//   const location = useLocation();
//   const isAdminRoute = location.pathname.startsWith("/admin");

//   if (isAdminRoute) {
//     return (
//       <MsalProvider instance={msalInstance}>
//         <Routes>{AdminRoutes()}</Routes>
//       </MsalProvider>
//     );
//   }

//   return (
//     <AuthProvider>
//       <Routes>{UserRoutes()}</Routes>
//     </AuthProvider>
//   );
// }

// export default App;

import React, { useEffect, useState } from "react";
import { Routes, useLocation } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./auth/authConfig";
import UserRoutes from "./routes/userRoutes";
import AdminRoutes from "./routes/adminRoutes";
import { AuthProvider } from "./auth/AuthContext";
import GlassLoaderOverlay from "./components/GlassLoader";
import { usePageTracking } from "./components/customHook/usePageTracking";

const LoadingPage = () => <GlassLoaderOverlay />;
const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  const [msalReady, setMsalReady] = useState(false);
  useEffect(() => {
    const initMsal = async () => {
      try {
        await msalInstance.initialize();
        setMsalReady(true);
      } catch (err) {
        console.error("MSAL initialization failed", err);
      }
    };
    initMsal();
  }, []);
  usePageTracking();
  if (!msalReady) return <LoadingPage />;
  return <RouteHandler />;
}

function RouteHandler() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");


  if (isAdminRoute) {
    return (
      <MsalProvider instance={msalInstance}>
        <Routes>{AdminRoutes()}</Routes>
      </MsalProvider>
    );
  }
  return (
    <AuthProvider>
      <Routes>{UserRoutes()}</Routes>
    </AuthProvider>
  );
}

export default App;